<form class="edit-form" *ngIf="!isLoading && clients && dictionaries" [formGroup]="editForm" (submit)="onSubmit()">

  <mat-form-field>
    <mat-label>{{ 'repository.transportTypes.edit.name.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="name">
    <mat-error>{{ 'repository.transportTypes.edit.name.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <app-autocomplete [control]="getControl('dictionary')" [list]="dictionaries"
    label="repository.transportTypes.edit.dictionary.label"
    errorMsg="repository.transportTypes.edit.dictionary.errorMessage">
  </app-autocomplete>

  <ng-container>
    <app-autocomplete [control]="getControl('client')" [list]="clients"
      label="repository.transportTypes.edit.client.label" errorMsg="repository.transportTypes.edit.client.errorMessage">
    </app-autocomplete>
  </ng-container>

  <ng-container
    *ngIf="editForm.get('dictionary')?.value && editForm.get('dictionary')?.value?.code === 'lots' && sites">
    <app-autocomplete [control]="getControl('site')" [list]="sites" label="repository.transportTypes.edit.site.label"
      errorMsg="repository.transportTypes.edit.site.errorMessage">
    </app-autocomplete>
  </ng-container>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm"
    [disabling]="editForm.invalid"></app-validate-and-cancel>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>